import { useTranslation } from "react-i18next";
import React, { useContext } from "react";
import Feature from "./Feature";
import "../../styles/app/FeatureSection.css";
import { ThemeContext } from "../../contexts/ThemeContext";

const FeatureSection: React.FC = () => {
  const { t } = useTranslation();

  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { isLightMode } = themeContext;

  const props = [
    {
      title: t("featureSection.0.title"),
      desc: t("featureSection.0.desc"),
      features: [
        t("featureSection.0.features.0"),
        t("featureSection.0.features.1"),
        t("featureSection.0.features.2"),
        t("featureSection.0.features.3"),
      ],
    },
    {
      title: t("featureSection.1.title"),
      desc: t("featureSection.1.desc"),
      features: [
        t("featureSection.1.features.0"),
        t("featureSection.1.features.1"),
        t("featureSection.1.features.2"),
        t("featureSection.1.features.3"),
      ],
    },
    {
      title: t("featureSection.2.title"),
      desc: t("featureSection.2.desc"),
      features: [
        t("featureSection.2.features.0"),
        t("featureSection.2.features.1"),
        t("featureSection.2.features.2"),
        t("featureSection.2.features.3"),
      ],
    },
  ];
  return (
    <section
      className="feature-section"
      data-theme={isLightMode ? "light" : "dark"}
    >
      {props.map((p, index) => (
        <Feature key={index} {...p} />
      ))}
    </section>
  );
};

export default FeatureSection;
